module.exports = __webpack_public_path__ + "static/wave-aa6824184222f1dd078d04bfbfbdf079.png";